import React, {
  useState,
  useCallback,
  useImperativeHandle,
  forwardRef,
} from 'react'
import Quill from 'quill'
import './index.scss'
import qs from 'qs'

const Size = Quill.import('attributors/style/size')
Size.whitelist = ['13px', '14px', '16px']
Quill.register(Size, true)

const classNames = require('classnames')

const fontStyles = [
  [['bold'], ['italic'], ['underline'], ['strike']],
  [
    ['13px', 'size'],
    ['14px', 'size'],
    ['16px', 'size'],
  ],
]

const colors = [
  ['rgba(38, 38, 38, 0.87)', 'color'],
  ['rgba(6, 6, 6, 0.45)', 'color'],
  ['rgba(38, 38, 38, 0.3)', 'color'],
  ['#f34c3c', 'color'],
  ['#ffb91c', 'color'],
  ['#14c0ff', 'color'],
]

const { flutter } = qs.parse(window.location.search.substr(1)) as {
  flutter: string | undefined
}

interface MenuBoxProps {
  showKeyboard: (event: React.MouseEvent) => void
  uploader: React.MutableRefObject<HTMLInputElement | undefined>
  checkFiles: CheckFilesFn
  beforeLeave: React.MutableRefObject<() => void>
  menuType: MenuType
  editorRef: React.MutableRefObject<Quill | null>
  setShowMenuBox: (b: MenuType) => void
}

const MenuBox = forwardRef((props: MenuBoxProps, ref: any) => {
  const {
    showKeyboard,
    uploader,
    checkFiles,
    beforeLeave,
    menuType,
    editorRef,
    setShowMenuBox,
  } = props

  const [editorFormat, setEditorFormat] = useState<{ [k: string]: string }>({})

  const setFormat = useCallback(() => {
    const editor = editorRef.current
    if (!editor) return
    const format = editor.getFormat()
    setEditorFormat({
      ...format,
      size: format.size || '14px',
      color: format.color || 'rgba(38, 38, 38, 0.87)',
    })
  }, [editorRef])

  useImperativeHandle(ref, () => ({
    setFormat,
    editorFormat,
  }))

  function uploadLocalFiles() {
    uploader.current?.click()
    editorRef.current?.blur()
    setShowMenuBox(false)
  }

  async function goFlyDoc(isWechat: boolean) {
    try {
      editorRef.current?.blur()
      if (!(await checkFiles({ checkOnly: true, type: 'tempLeave' }))) return
      console.log('go fly')

      window.localStorage.setItem(
        'file_origin',
        isWechat ? '微信文件' : '飞项文档'
      )
      beforeLeave.current()
      if (flutter) {
        window.location = ('js://webview?trigger=fly_file' as unknown) as Location
        return
      }
      wx.miniProgram.redirectTo({
        url: `/pages/files-selector/index?isH5=1&getWechatFiles=${
          isWechat ? 1 : ''
        }`,
        complete() {
          console.log('redirect ok')
        },
        fail(e) {
          console.log('redirect error', e)
        },
      })
    } catch (e) {
      console.log('leave for fly doc error', e)
    }
  }

  const styleChoose = (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>,
    { k, v }: { k: string; v: string }
  ) => {
    const editor = editorRef.current
    if (!editor) return
    e.preventDefault()

    editor.disable()

    if (k) {
      editor.format(k, v, 'silent')
    } else {
      editor.format(v, !editorFormat[v], 'silent')
    }
    setFormat()
  }

  return menuType ? (
    <div className="menuBox">
      <div className="menuBar">
        <img
          src="./images/icons/keyboard.png"
          alt=""
          className="icon"
          onClick={showKeyboard}
        />
      </div>
      {menuType === 'file' && (
        <div className="file">
          {!flutter ? (
            <div className="file-item" onClick={goFlyDoc.bind(null, true)}>
              <img
                src="./images/icons/file_wechat.png"
                alt=""
                className="icon"
              />
              <span>微信文件</span>
            </div>
          ) : (
            <></>
          )}
          <div className="file-item" onClick={goFlyDoc.bind(null, false)}>
            <img src="./images/icons/file_fly.png" alt="" className="icon" />
            <span>飞项文档</span>
          </div>
          <div className="file-item" onClick={uploadLocalFiles}>
            <img src="./images/icons/file_local.png" alt="" className="icon" />
            <span>本地文件</span>
          </div>
        </div>
      )}

      {menuType === 'font' && (
        <div className="font">
          {fontStyles.map((bars, idx) => (
            <div key={`bar-${idx}`} className="bar">
              {bars.map(([v, k]) => (
                <div
                  className={classNames('cell', {
                    cell_active: k ? editorFormat[k] === v : editorFormat[v],
                  })}
                  key={v}
                  onMouseDown={(e) => styleChoose(e, { k, v })}
                >
                  <img
                    className={classNames({ 'icon-size': k })}
                    src={`./images/icons/${
                      (k ? editorFormat[k] === v : editorFormat[v])
                        ? v + '_white'
                        : v
                    }.png`}
                    alt=""
                  />
                </div>
              ))}
            </div>
          ))}
          <div className="bar bar-color">
            {colors.map(([v, k]) => (
              <div
                key={v}
                className="color-dot-wrapper"
                onMouseDown={(e) => styleChoose(e, { k, v })}
                style={{
                  backgroundColor: editorFormat[k] === v ? v : 'transparent',
                }}
              >
                <div
                  className="color-dot"
                  style={{
                    backgroundColor: v,
                  }}
                ></div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  ) : (
    <></>
  )
})

export default MenuBox
